import { render, staticRenderFns } from "./WorkInfoDetailList.vue?vue&type=template&id=e2fa0fc6&scoped=true"
import script from "./WorkInfoDetailList.vue?vue&type=script&lang=js"
export * from "./WorkInfoDetailList.vue?vue&type=script&lang=js"
import style0 from "./WorkInfoDetailList.vue?vue&type=style&index=0&id=e2fa0fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fa0fc6",
  null
  
)

export default component.exports